import type { FC } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as ArrowRight } from '../assets/icons/arrow-right.svg';
import { RoutePath } from '../config';
import { TimezoneSelector } from '../components';

export const SettingsPage: FC = () => {
  return (
    <>
      <h1 className="mb-4 text-4xl text-brand-6 font-bold">Settings</h1>
      <div className="p-7 w-3/5 bg-white rounded-3xl flex flex-col gap-5">
        <Link className="flex justify-between items-center gap-5" to={RoutePath.ChangePassword}>
          Change password
          <ArrowRight />
        </Link>
        <div className="flex justify-between items-center gap-5">
          <span>Timezone</span>
          <TimezoneSelector />
        </div>
      </div>
    </>
  );
};
